import { render, staticRenderFns } from "./actor-overview.vue?vue&type=template&id=2d6752e7&scoped=true&"
import script from "./actor-overview.vue?vue&type=script&lang=ts&"
export * from "./actor-overview.vue?vue&type=script&lang=ts&"
import style0 from "./actor-overview.vue?vue&type=style&index=0&id=2d6752e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6752e7",
  null
  
)

export default component.exports